/**
 * Sektion Termine (lesend).
 * Aus pages/ProjektDetailPage.tsx herausgelöst (Plan Projekt-Tracking, Etappe 2) —
 * verschoben, nicht umgeschrieben.
 */
import { useNavigate } from "react-router-dom";
import { useProjektTermine } from "../../hooks/usePlanung";
import type { ProjektTermin } from "../../lib/types";
import { h1Zahl, heute } from "./seiteHilfen";

/* ══ Termine ═════════════════════════════════════════════════════════════ */

/**
 * Die Termine des Projekts — lesend.
 *
 * Bisher zeigte die Seite nur die Stundenzeilen, also das Ergebnis. Wer wissen
 * wollte, wann wer eingeplant war, musste in den Planer wechseln. Geändert
 * wird ein Termin weiterhin dort: sein Datum hängt am Termin selbst, nicht am
 * Einsatz, und ein Umhängen ist eine Planungsoperation.
 */
export function TerminBlock({ projektId }: { projektId: string }) {
  const { data: termine = [], isLoading } = useProjektTermine(projektId);
  const navigate = useNavigate();
  const kommend = heute();

  if (isLoading) return <div className="vg-detail-section-hint">Termine werden geladen …</div>;
  if (termine.length === 0) {
    return <div className="vg-detail-section-hint">Für dieses Projekt ist noch kein Termin geplant.</div>;
  }

  const stunden = termine.reduce((s, t) => s + t.stunden, 0);
  return (
    <div className="vg-unterblock">
      <p className="vg-detail-section-hint">
        {termine.length} Termin{termine.length === 1 ? "" : "e"} · {h1Zahl(stunden)} h eingeplant.
        Geändert werden Termine in der Planung.
      </p>
      <table className="vg-tabelle">
        <thead>
          <tr>
            <th>Datum</th><th>Titel</th><th>Personen</th>
            <th className="is-num">Std.</th><th className="is-aktion" />
          </tr>
        </thead>
        <tbody>
          {termine.map((t: ProjektTermin) => (
            <tr key={t.id} className={t.datum >= kommend ? "vg-termin-kommend" : undefined}>
              <td>
                {t.datum || "—"}
                {t.datum >= kommend && <span className="vg-proj-tag" style={{ marginLeft: 6 }}>geplant</span>}
              </td>
              <td>
                {t.titel || "Einsatz"}
                {t.notiz && <small style={{ display: "block", color: "var(--vg-text-3)" }}>{t.notiz}</small>}
              </td>
              <td className="is-muted">
                {t.personen.length ? t.personen.join(" · ") : `noch niemand${t.benoetigte_helfer ? ` (${t.benoetigte_helfer} gesucht)` : ""}`}
              </td>
              <td className="is-num">{h1Zahl(t.stunden)}</td>
              <td className="is-aktion">
                <button
                  type="button"
                  className="vg-icon-btn"
                  title="In der Planung öffnen"
                  onClick={() => navigate(`/planung?datum=${t.datum}`)}
                >
                  ↗
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
